<template>
  <div>
    <small class="label">{{ field_label }}</small>
    <v-select v-on:input="onInput($event)" @search="onSearch"
              :clearable="true" name="customer_id" placeholder=""
              label="company_name" v-model="selected_value"
              :options="customers_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
      <template slot="no-options">
        type to search customer
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const DropDownRepository = RepositoryFactory.get('drop_down')

export default {
  name: "CustomerDropdown",
  props: {
    selected_customer_data: {
      default: null
    },
    field_label: {
      default: 'Search Customer'
    }
  },
  data() {
    return {
      customers_list: [],
      selected_value: null
    }
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    onInput: function (param) {
      this.$emit('onInput', param)
    },
    onSelected: function (param) {

    },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getCustomersList(`filter[search]=${search}&filter[status]=`)
      vm.customers_list = data.data
      loading(false);
    }, 350),
  },
  watch: {
    $props : {
      handler() {
        if(!this.selected_customer_data) {
          this.selected_value = null
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
